// src/redux/reducer.js

const toArr = (p) => (Array.isArray(p) ? p : p == null ? [] : [p]);
const toObj = (p) =>
  p && typeof p === "object" && !Array.isArray(p) ? p : {};

export const initialState = {
  // Resume sections
  personalInfo: {},
  workExperience: [],
  education: [],
  keySkills: [],
  addSoftSkills: [],
  socialMediaLinks: [],
  addReference: [],
  projectData: [],
  addLanguage: [],
  honorAndaward: [],
  addHobies: [],
  certificateData: [],

  // Template
  templatePage: [],
  selectedTemplateId: "1",

  // OCR
  extractedResumeText: null,

  // Letters
  coverletterss: [],
  coverLetterData: [],
  experienceLetterData: {},
  offerLetterData: {},
  coverLetterTemplateId: null,

  // Images / misc
  images: [],
  techImages: [],
  coverImages: [],

  // Legacy (Shadi card etc.)
  shadiData: [],
  shadicarddata: [],
  selectedIcon: [],
  googleData: [],
  friend_To_Talk: [],
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    /* ---------- RESUME SECTIONS ---------- */
    case "personalinfo_data":
      return { ...state, personalInfo: toObj(action.payload) };
    case "workEx_data":
      return { ...state, workExperience: toArr(action.payload) };
    case "education_data":
      return { ...state, education: toArr(action.payload) };
    case "keyskills_data":
      return { ...state, keySkills: toArr(action.payload) };
    case "add_soft_skills":
      return { ...state, addSoftSkills: toArr(action.payload) };
    case "social_media":
      return { ...state, socialMediaLinks: toArr(action.payload) };
    case "add_references":
      return { ...state, addReference: toArr(action.payload) };
    case "Project_Data":
      return { ...state, projectData: toArr(action.payload) };
    case "add_Language":
      return { ...state, addLanguage: toArr(action.payload) };
    case "honor_and_award":
      return { ...state, honorAndaward: toArr(action.payload) };
    case "add_Hobbies":
      return { ...state, addHobies: toArr(action.payload) };
    case "certificate_Data":
      return { ...state, certificateData: toArr(action.payload) };

    /* ---------- TEMPLATE ---------- */
    case "template_page":
      return { ...state, templatePage: toArr(action.payload) };
    case "set_template_page":
      return { ...state, selectedTemplateId: String(action.payload ?? "1") };

    /* ---------- OCR ---------- */
    case "extracted_resume_text":
      return { ...state, extractedResumeText: action.payload };

    /* ---------- LETTERS ---------- */
    case "cover_letter":
      return { ...state, coverletterss: toArr(action.payload) };
    case "cover-Letter-Data":
      return { ...state, coverLetterData: toArr(action.payload) };
    case "experience-Letter-Data":
      return { ...state, experienceLetterData: toObj(action.payload) };
    case "offer-Letter-Data":
      return { ...state, offerLetterData: toObj(action.payload) };
    case "SELECT_COVER_LETTER_TEMPLATE":
      return { ...state, coverLetterTemplateId: action.payload };

    /* ---------- IMAGES / MISC ---------- */
    case "LOAD_IMAGES":
      return { ...state, images: toArr(action.payload) };
    case "TECH_IMAGES":
      return { ...state, techImages: toArr(action.payload) };
    case "COVER_IMAGE":
      return { ...state, coverImages: toArr(action.payload) };
    case "Form_Data":
      return { ...state, shadiData: toArr(action.payload) };
    case "selected_Shadi_Card":
      return { ...state, shadicarddata: toArr(action.payload) };
    case "selected_Icon":
      return { ...state, selectedIcon: toArr(action.payload) };
    case "google_data":
      return { ...state, googleData: toArr(action.payload) };
    case "friendToTalk":
      return { ...state, friend_To_Talk: toArr(action.payload) };

    default:
      return state;
  }
};

export default reducer;